<template>
  <div class="item">
    <label>{{ label }}</label>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Item',
  props: {
    label: {
      type: String,
      default: '项'
    }
  }
}
</script>

<style lang="less" scoped>
.item {
  display: flex;
  align-items: center;
  > label {
    color: rgba(0, 0, 0, 0.85);
    &::after {
      content: ':';
      position: relative;
      top: -0.5px;
      margin: 0 8px 0 2px;
    }
  }
}
</style>
